export const gs75 = {
    default: "#15614E",
    subtle: "#00815C",
    strong: "#1D4B43",
};
